module.exports = __webpack_public_path__ + "static/media/right.a6dfbed7.svg";